import { render, staticRenderFns } from "./Groupclients.vue?vue&type=template&id=1cb979bb&scoped=true"
import script from "./Groupclients.vue?vue&type=script&lang=js"
export * from "./Groupclients.vue?vue&type=script&lang=js"
import style0 from "./Groupclients.vue?vue&type=style&index=0&id=1cb979bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb979bb",
  null
  
)

export default component.exports